import React from 'react';
import { Eye, CreditCard, RefreshCw, Box } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = [
  Eye,
  CreditCard,
  RefreshCw,
  Box,
];

export const Technology = () => {
  const { technology } = mockData;

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 tracking-tight">
            {technology.title}
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8">{technology.subtitle}</p>
        </div>

        {/* Technology Features */}
        <div className="relative">
          {/* Central Circle */}
          <div className="hidden lg:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-gradient-to-br from-[#2AD7C5]/20 to-[#2AD7C5]/5 rounded-full blur-3xl"></div>

          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 relative z-10">
            {technology.features.map((feature, index) => {
              const Icon = iconMap[index];
              return (
                <div
                  key={feature.id}
                  className="group p-8 rounded-2xl bg-white border-2 border-gray-100 hover:border-[#2AD7C5] transition-all duration-300 hover:shadow-lg"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 bg-[#2AD7C5]/10 rounded-xl flex items-center justify-center group-hover:bg-[#2AD7C5]/20 transition-colors duration-300">
                        <Icon className="text-[#2AD7C5]" size={28} />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Technology Visual */}
          <div className="mt-16 relative rounded-2xl overflow-hidden shadow-xl max-w-4xl mx-auto">
            <img
              src={technology.imageUrl}
              alt="Grabo.ai Intelligent Technology"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
